











































import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalAdd from './ModalAdd.vue'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'
@Component({
  components: {
    'modal-add': ModalAdd,
    'modal-delete-all': ModalDeleteAll,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public clearRowSelected
  @Prop({}) public imageDataCategory
  @Prop({}) public isDisabled

  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    MasterCarStateDataModule.deleteMasterCar({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
